module.exports = __webpack_public_path__ + "static/media/tools.5594ca60.png";